import { html } from 'htm/preact'
import { UNITS } from '../units.js'

export default function UnitPicker({ value, onChange, compatibleUnits }) {
  const displayUnits = compatibleUnits || UNITS
  return html`
    <div class="unit-picker">
      ${displayUnits.map(u => html`
        <button
          type="button"
          class="unit-picker__btn ${value === u ? 'is-selected' : ''}"
          onClick=${() => onChange(u)}
          key=${u}
        >${u}</button>
      `)}
    </div>
  `
}